// Floating pastel blobs used behind page content.
// Usage: <PageBackground variant="cyan-lav" /> at the top of a page component.
export default function PageBackground({ variant = "default" }) {
  // Each variant defines a different arrangement of blobs.
  const layouts = {
    default: [
      { cls: "blob-cyan", size: 500, top: "-160px", left: "-140px", delay: "0s", op: 0.55 },
      { cls: "blob-lav",  size: 500, top: "40%",   right: "-140px", delay: "5s", op: 0.4 },
      { cls: "blob-mint", size: 400, top: "78%",   left: "22%",    delay: "8s", op: 0.35 },
    ],
    "cyan-lav": [
      { cls: "blob-cyan", size: 520, top: "-120px", left: "-120px", delay: "0s", op: 0.55 },
      { cls: "blob-lav",  size: 480, top: "55%",   right: "-160px", delay: "3s", op: 0.45 },
    ],
    "mint-cyan": [
      { cls: "blob-mint", size: 500, top: "-140px", left: "-120px", delay: "0s", op: 0.5 },
      { cls: "blob-cyan", size: 460, top: "60%",   right: "-160px", delay: "4s", op: 0.5 },
    ],
    portal: [
      { cls: "blob-cyan", size: 420, top: "-120px", left: "-140px", delay: "0s", op: 0.35 },
      { cls: "blob-lav",  size: 420, top: "50%",   right: "-140px", delay: "6s", op: 0.3 },
    ],
    dashboard: [
      { cls: "blob-cyan", size: 380, top: "-100px", right: "-100px", delay: "0s", op: 0.3 },
      { cls: "blob-mint", size: 380, top: "60%",   left: "-100px", delay: "5s", op: 0.28 },
    ],
  };
  const items = layouts[variant] || layouts.default;
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
      {items.map((b, i) => (
        <div
          key={i}
          className={`blob ${b.cls} blob-float`}
          style={{
            width: b.size,
            height: b.size,
            top: b.top,
            left: b.left,
            right: b.right,
            opacity: b.op,
            animationDelay: b.delay,
          }}
        />
      ))}
    </div>
  );
}
